export default "__VITE_ASSET__DS$I5nzm__"